// extracted by mini-css-extract-plugin
module.exports = {"sticky-note":"StickyNote_sticky-note__5t2bX","stickyNote":"StickyNote_sticky-note__5t2bX","title":"StickyNote_title__c5EpA","text":"StickyNote_text__oyLDl"};